import { Box, useTheme } from '@mui/material';

interface MemberPageViewProps {
  children: React.ReactNode;
  isSelected?: boolean;
}

const MemberPageView = ({
  children,
  isSelected = false,
}: MemberPageViewProps) => {
  const theme = useTheme();

  return (
    
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: '12px 0 16px',
        backgroundColor: 'white',
        borderRadius: theme.app.borderRadius.lessRounded,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        boxSizing: 'border-box',

        '@media (max-width: 1068px)': {
          borderRight: 'none',
          display: isSelected ? 'flex' : 'none',
          width: '100%',
        },
      }}
    >
      <Box
        sx={{
          flex: '1 1 0%', // More explicit flex shorthand: grow, shrink, basis
          overflow: 'auto',
          minHeight: 0,
          width: '100%',
          // Using flex-basis: 0% instead of height: 0 for better cross-browser compatibility
          // This achieves the same constraint behavior without iOS Safari height calculation bugs
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MemberPageView;
